import React from 'react';
import {Permissions, UserDepartments} from "../../common/Constants";

export default {

    "owner":[
        {
            "path": "/dashboard",
            "icon": "fa fa-dashboard",
            "label": "Dashboard",
        },
        {
            "path": "/requests",
            "icon": "icon-docs",
            "label": "Tractor Requests",
            "$permissions$": [ Permissions.Requests.View ]
        },
        {
            "path": "/payments",
            "icon": "fa fa-money",
            "label": "Payments",
            "$permissions$": [ Permissions.Payments.View ]
        },
        {
            "path": "/tractors",
            "icon": <img src="/img/avatars/tractor_logo_white.png" style={{marginBottom: '4px' , marginLeft: '3px' , marginRight: '9px'}} width={16} height={16}/>,
            "label": "Tractors",
            "$permissions$": [ Permissions.Tractors.View ]
        },
        {
            "path": "/operators",
            "icon": "fa fa-user",
            "label": "Tractor Operators",
            "$permissions$": [ Permissions.Operators.View ]
        },
        {
            "path": "/maps",
            "icon": "fa fa-map-marker",
            "label": "Tractors Map View",
            "$permissions$": [ Permissions.User.MonitorTrackers ]
        }
    ],
    "fbo":[
        {
            "path": "/dashboard",
            "icon": "fa fa-dashboard",
            "label": "Dashboard"
        },
        {
            "path" : "/farmers",
            "icon":  "icon-user",
            "label": "Farmers",
            "$permissions$": [ Permissions.Farmers.View ]
        },
        {
            "path": "/requests",
            "icon": "icon-docs",
            "label": "Tractor Requests",
            "$permissions$": [ Permissions.Requests.View ]
        }
    ],
    "farmer":[
        {
            "path": "/dashboard",
            "icon": "fa fa-dashboard",
            "label": "Dashboard"
        },
        {
            "path": "/requests",
            "icon": "icon-docs",
            "label": "Tractor Requests",
            "$permissions$": [ Permissions.Requests.View ]
        }
    ],
    "admin":[
        {
            "path": "/dashboard",
            "icon": "fa fa-dashboard",
            "label": "Dashboard"
        },
        {
            "path": "/requests",
            "icon": "icon-docs",
            "label": "Tractor Requests",
            "$permissions$": [ Permissions.Requests.View ]
        },
        {
            "path" : "/farmers",
            "icon":  "icon-user",
            "label": "Farmers",
            "$permissions$": [ Permissions.Farmers.View ]
        },
        {
            "path" : "/fbo",
            "icon":  "icon-people",
            "label": "FBOs",
            "$permissions$": [ Permissions.FBO.View ]
        },
        {
            "path": "/tractors",
            "icon": <img src="/img/avatars/tractor_logo_white.png" style={{marginBottom: '4px' , marginLeft: '3px' , marginRight: '9px'}} width={16} height={16}/>,
            "label": "Tractors",
            "$permissions$": [ Permissions.Tractors.View ]
        },
        {
            "path": "/operators",
            "icon": "fa fa-user",
            "label": "Tractor Operators",
            "$permissions$": [ Permissions.Operators.View ]
        },
        {
            "path": "/tractor_owners",
            "icon": "fa fa-user-secret",
            "label": "Tractor Owners",
            "$permissions$": [ Permissions.TractorOwners.View ]
        },
        {
            "path": "/transactions",
            "icon": "fa fa-money",
            "label": "Transactions",
            "$permissions$": [ Permissions.Transactions.View ]
        },
        {
            "path": "/maps",
            "icon": "fa fa-map-marker",
            "label": "Tractors Map View",
            "$permissions$": [ Permissions.User.MonitorTrackers ]
        },
        {
            "title":"Extras",
            "groups": [
                {
                    "icon": "icon-folder",
                    "label": "Services",
                    "subLinks": [
                        {
                            "path": "/services/ussd",
                            "icon": "icon-phone",
                            "label": "USSD"
                        },
                     /*   {
                            "path": "/services/broadcast",
                            "icon": "fa fa-send",
                            "label": "Broadcasting"
                        }*/
                    ],
                    "$permissions$": [ Permissions.USSDServices.View ]

                },
                {
                    "$element$": "separator"
                },
                {
                    "icon": "fa fa-support",
                    "label": "Support",
                    "subLinks": [
                       /* {
                            "path": "/support/tickets_management",
                            "icon": "fa fa-ticket",
                            "label": "Tickets"
                        },*/
                        {
                            "path": "/support/feedback",
                            "icon": "fa fa-comment",
                            "label": "User Feedback",
                            "$department$": [UserDepartments.IT]
                        }
                    ],
                },
                {
                    "$element$": "separator"
                },
                {
                    "icon": "fa fa-archive",
                    "label": "Finance",
                    "subLinks": [
                        {
                            "path": "/finance/payout",
                            "icon": "fa fa-money",
                            "label": "Payments"
                        },
                        /*{
                            "path": "/finance/credit/virtual/payments",
                            "icon":"fa fa-bank",
                            "label":"Yolum",
                            "$permissions$": [ Permissions.VirtualCredit.View ]
                        }*/
                    ],
                    "$department$": [UserDepartments.Finance]
                },
                {
                    "$element$": "separator"
                },
                {
                    "icon" : "fa fa-folder",
                    "label": "Management",
                    "subLinks": [
                        {
                            "path": "/management/settings",
                            "icon":"fa fa-gears",
                            "label":"Settings"
                        }
                    ],
                    "$auth$": "super",
                    "$department$": [UserDepartments.IT]
                },

            ]
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/NavLinks.js